// utils/focus.js

/**
 * Focus the first editable field inside a container
 * Skips hidden, read-only, or disabled inputs
 * @param {HTMLElement} root - The root container to search within
 */
export function focusFirstEditable(root) {
  if (!root) return;

  const selector = [
    'input:not([type="hidden"]):not([readonly]):not([disabled])',
    "textarea:not([readonly]):not([disabled])",
    "select:not([disabled])",
    "button:not([disabled])",
    '[tabindex]:not([tabindex="-1"])',
  ].join(",");

  const el = root.querySelector(selector);
  if (el) el.focus({ preventScroll: true });
  else root.focus({ preventScroll: true });
}
